import { render, staticRenderFns } from "./veSbzcCdRevertShow.vue?vue&type=template&id=83043f1c&scoped=true"
import script from "./veSbzcCdRevertShow.vue?vue&type=script&lang=js"
export * from "./veSbzcCdRevertShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83043f1c",
  null
  
)

export default component.exports